import { render, staticRenderFns } from "./paginatedButtonGroup.vue?vue&type=template&id=1191e0de&"
import script from "./paginatedButtonGroup.vue?vue&type=script&lang=js&"
export * from "./paginatedButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports